/**
 * 灵兽的展示信息:表情、自称口吻、成长阶段 —— 各页面共用,避免胶囊里
 * 永远是 🐵「俺老孙」(测评时发现选了龙的孩子也在听猴子说话)
 */

export const SPECIES = {
  dragon: { emoji: '🐉', label: '东海神龙', teach: '龙宫里的窍门,我讲给你听,你来动手!', teachOlder: '龙宫里的门道,我讲给你听,你来动手验证。' },
  monkey: { emoji: '🐵', label: '齐天大圣', teach: '俺老孙画给你看,你来动手!', teachOlder: '俺老孙画给你看,你来动手验证。' },
  phoenix: { emoji: '🐦', label: '南天火凤', teach: '火凤带你看一遍,你来动手!', teachOlder: '火凤带你看一遍,你来动手验证。' },
  fusang: { emoji: '🌳', label: '扶桑神木', teach: '神木慢慢讲给你听,你来动手!', teachOlder: '神木慢慢讲给你听,你来动手验证。' },
  qilin: { emoji: '🦄', label: '祥瑞麒麟', teach: '麒麟画给你看,你来动手!', teachOlder: '麒麟画给你看,你来动手验证。' },
};

export function speciesEmoji(species) {
  return SPECIES[species]?.emoji || '🥚';
}

// 9-12 岁用 teachOlder(不说「窍门」之类的低龄词)
export function teachLine(species, ageBand) {
  const older = ageBand === '9-12';
  return (older ? SPECIES[species]?.teachOlder : SPECIES[species]?.teach) ||
    (older ? '我画给你看,你来动手验证。' : '我画给你看,你来动手!');
}

// 与后端 GUARDIAN_STAGES 顺序一致
export const STAGES = ['egg', 'hatchling', 'juvenile', 'adult', 'legend'];

export const STAGE_LABEL = {
  egg: '灵兽蛋',
  hatchling: '破壳幼崽',
  juvenile: '小将',
  adult: '神将',
  legend: '圣兽',
};

// 每一阶在卡片上的大小和光环,让"长大"看得见
export const STAGE_LOOK = {
  egg: { size: 'text-5xl', ring: '' },
  hatchling: { size: 'text-6xl', ring: '' },
  juvenile: { size: 'text-7xl', ring: 'ring-4 ring-qiji-mint' },
  adult: { size: 'text-8xl', ring: 'ring-4 ring-qiji-gold' },
  legend: { size: 'text-8xl', ring: 'ring-8 ring-qiji-gold animate-pulse' },
};

export function previousStage(stage) {
  const i = STAGES.indexOf(stage);
  return i > 0 ? STAGES[i - 1] : stage;
}
